
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asia/[param]/[month]/[day]/[slug]",
      function () {
        return require("private-next-pages/asia/[param]/[month]/[day]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asia/[param]/[month]/[day]/[slug]"])
      });
    }
  